import React from "react";

type Props = {
  children: React.ReactNode;
};

const InfoWrapper = ({ children }: Props) => (
  <div className="flex flex-col lg:gap-y-5">{children}</div>
);

export default InfoWrapper;
